import { createTheme } from '@material-ui/core/styles';

const white = "#fff";
const grey = "#757575";

const primaryDefault = "#30B81F";
const secondaryDefault = "#0E67BA";

export default class Theme {

  static get(primaryColor, secondaryColor) {
    const primary = primaryColor || primaryDefault;
    const secondary = secondaryColor || secondaryDefault;

    const theme = createTheme({
      palette: {
        primary: {
          main: primary,
          contrastText: white,
        },
        secondary: {
          main: secondary,
          contrastText: white,
        }
      },
      typography: {
        fontFamily: "\"museo-sans\", \"Helvetica\", \"Arial\", sans-serif",
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 576,
          md: 768,
          lg: 992,
          xl: 1200,
        },
      },
      overrides: {
        MuiButton: {
          containedPrimary: {
            '&:hover': {
              color: white,
            },
            '&:focus': {
              boxShadow: `0 0 5px 0px ${primary}`,
              outline: 'none'
            }
          },
          containedSecondary: {
            '&:focus': {
              outline: 'none'
            }
          },
          outlined: {
            borderWidth: '2px',
            '&:focus': {
              boxShadow: `0 0 5px 0px ${primary}`,
              outline: 'none'
            }
          },
          outlinedPrimary: {
            borderWidth: '2px',
            '&:hover': {
              color: primary,
              borderWidth: '2px',
            },
            '&:focus': {
              boxShadow: `0 0 5px 0px ${primary}`,
              outline: 'none'
            }
          },
          outlinedSecondary: {
            borderWidth: '2px',
            '&:hover': {
              color: white,
              borderWidth: '2px',
            },
            '&:focus': {
              boxShadow: `0 0 5px 0px ${secondary}`,
              outline: 'none'
            }
          },
          text: {
            padding: 0,
            '&:focus': {
              outline: 'none',
            },
            textTransform: 'none',
          },
          textPrimary: {
            '&:focus': {
              boxShadow: `0 0 5px 0px ${primary}`,
              outline: 'none'
            }
          },
        },
        MuiTextField: {
          root: {
            backgroundColor: white,
            borderRadius: '4px',
          }
        },
        MuiOutlinedInput: {
          notchedOutline: {
            borderColor: grey,
          }
        },
      }
    });
    return theme;
  }
}


// WEBPACK FOOTER //
// ./src/components/Theme/Theme.js